<template>
  <div class="load-more">
    <div class="ball-loader" v-if="isShow && !isError">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="load-retry-box" v-if="isError">
      <span class="retry-tip">网络加载稍有延迟</span>
      <button class="retry-btn" @click="$emit('retry')">
        <v-icon x-small class="mr-1">mdi-refresh</v-icon>点击重新加载
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "load-more",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.load-more {
  max-width: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 16px 0 24px;

  .load-retry-box {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .retry-tip {
      font-size: 13px;
      color: #64748b;
    }

    .retry-btn {
      display: inline-flex;
      align-items: center;
      padding: 4px 12px;
      font-size: 12px;
      font-weight: 600;
      color: #ffffff;
      background: linear-gradient(135deg, #10b981 0%, #0d9488 100%);
      border-radius: 14px;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 6px rgba(16, 185, 129, 0.35);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.5);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  @keyframes ball-loader {
    50% {
      opacity: 0.3;
      -webkit-transform: scale(0.4);
      transform: scale(0.4);
    }

    100% {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  .ball-loader > div:nth-child(1) {
    top: 18px;
    left: 0;
    -webkit-animation: ball-loader 1.2s -0.96s infinite linear;
    animation: ball-loader 1.2s -0.96s infinite linear;
  }

  .ball-loader > div:nth-child(2) {
    top: 13.05px;
    left: 13.05px;
    -webkit-animation: ball-loader 1.2s -0.84s infinite linear;
    animation: ball-loader 1.2s -0.84s infinite linear;
  }

  .ball-loader > div:nth-child(3) {
    top: 0;
    left: 18px;
    -webkit-animation: ball-loader 1.2s -0.72s infinite linear;
    animation: ball-loader 1.2s -0.72s infinite linear;
  }

  .ball-loader > div:nth-child(4) {
    top: -13.05px;
    left: 13.05px;
    -webkit-animation: ball-loader 1.2s -0.6s infinite linear;
    animation: ball-loader 1.2s -0.6s infinite linear;
  }

  .ball-loader > div:nth-child(5) {
    top: -18px;
    left: 0;
    -webkit-animation: ball-loader 1.2s -0.48s infinite linear;
    animation: ball-loader 1.2s -0.48s infinite linear;
  }

  .ball-loader > div:nth-child(6) {
    top: -13.05px;
    left: -13.05px;
    -webkit-animation: ball-loader 1.2s -0.36s infinite linear;
    animation: ball-loader 1.2s -0.36s infinite linear;
  }

  .ball-loader > div:nth-child(7) {
    top: 0;
    left: -18px;
    -webkit-animation: ball-loader 1.2s -0.24s infinite linear;
    animation: ball-loader 1.2s -0.24s infinite linear;
  }

  .ball-loader > div:nth-child(8) {
    top: 13.05px;
    left: -13.05px;
    -webkit-animation: ball-loader 1.2s -0.12s infinite linear;
    animation: ball-loader 1.2s -0.12s infinite linear;
  }

  .ball-loader {
    position: relative;
    width: 0;
    height: 0;
    margin: 20px auto;
  }

  .ball-loader > div {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: #10b981;
    margin: 2px;
  }
}
</style>
